// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tQvg","top":"styles_top__3O7WQ"};